import React, { useState } from "react";
import PropTypes from 'prop-types';
import { Modal, Spinner } from "react-bootstrap";
import { useSelector } from "react-redux";
import { BsCash } from "react-icons/bs";
import ImageWithBasePath from "../../img/imagewithbasebath";
import variables from "../../../style/scss/utils/_variables.scss";
import { DollarSign } from "react-feather";
import { formatearMoneda, priceRegex } from "../../utils";

const CustomTotalModal = ({ id, show = false, onHide, method, totalAmount, onSubmit }) => {

    const loading = useSelector((state) => state.loading);
    const [customAmount, setCustomAmount] = useState("");
    const [confirmAmount, setConfirmAmount] = useState("");
    const [confirm, setConfirm] = useState(false);

    const onConfirm = async () => {
        if (!confirm) {
            setConfirm(true);
        } else {
            onSubmit(customAmount);
        }
    }

    const onCustomAmountChanged = (e) => {
        e?.preventDefault();
        if (e?.target?.value === "") {
            setConfirm(false);
        }
        if (!isNaN(e?.target?.value)) {
            setCustomAmount(e?.target?.value);
        }
    }

    const isValidAmount = () => {
        if (customAmount === "" && confirmAmount === "") {
            return {
                valid: false,
                enabled: false,
                message: "Por favor confirma el Total recibido."
            };
        }

        if (customAmount !== "" && confirmAmount === "") {
            return {
                valid: false,
                enabled: true,
                message: "Por favor confirma el Total recibido."
            };
        }

        if (customAmount !== "" && confirmAmount !== "") {
            if (Number(customAmount) < Number(totalAmount)) {
                return {
                    valid: false,
                    enabled: false,
                    message: "El Total recibido no puede ser menor al Total calculado."
                };
            }

            if (Number(confirmAmount) === Number(customAmount)) {
                return {
                    valid: true,
                    enabled: true,
                    message: ""
                };
            }
        }

        return {
            valid: false,
            message: "Por favor confirma el Total recibido."
        };
    }

    const onModalHide = () => {
        onHide();
    }

    return (
        <Modal show={show} centered onHide={onModalHide} id={id} backdrop="static" keyboard={false}>
            <Modal.Header className="custom-modal-header" closeButton={!loading}>
                <h4>{method?.label}</h4>
            </Modal.Header>
            <Modal.Body className="text-center">
                <Modal.Title className='justify-content-center mb-4'>
                    {method
                        ? <ImageWithBasePath
                            src={method?.image}
                            style={{ width: 200, backgroundColor: method?.backgroundColor, padding: 5 }}
                            alt="Method"
                        />
                        : <BsCash size={88} color="#a5dc86" />
                    }
                </Modal.Title>
                <div className="row mb-3">
                    <div className="col-6 text-end">
                        <label className="col-form-label">Total calculado:</label>
                    </div>
                    <div className="col-6">
                        <div className="input-group">
                            <span className="input-group-text"><DollarSign size={15} color={variables.textColor} /></span>
                            <input
                                type="text"
                                className="form-control text-end"
                                id="totalAmount"
                                value={totalAmount?.toFixed(2)}
                                disabled
                            />
                        </div>
                    </div>
                </div>
                <div className="row mb-3">
                    <div className="col-6 text-end">
                        <label className="col-form-label">Total recibido:<span className="text-danger"> *</span></label>
                    </div>
                    <div className="col-6">
                        <div className="input-group">
                            <span className="input-group-text"><DollarSign size={15} color={variables.textColor} /></span>
                            <input
                                type="text"
                                className="form-control text-end"
                                id="givenAmount"
                                value={customAmount}
                                onChange={(e) => onCustomAmountChanged(e)}
                                pattern={priceRegex}
                                disabled={loading}
                            />
                        </div>
                    </div>
                </div>
                {customAmount &&
                    <h4 className="text-dark fw-bold mb-3">
                        Costos adicionales: {formatearMoneda(customAmount - totalAmount)}
                    </h4>
                }
                {confirm &&
                    <div className="row mb-3">
                        <div className="col-12">
                            <input
                                type="text"
                                className={!(isValidAmount()?.valid) ? "form-control text-center is-invalid" : "form-control text-center is-valid"}
                                maxLength={12}
                                value={confirmAmount}
                                onChange={(e) => setConfirmAmount(e.target.value)}
                                style={{ fontSize: '1.8rem' }}
                                disabled={loading}
                            />
                            <div className="invalid-feedback">
                                {isValidAmount()?.message}
                            </div>
                        </div>
                    </div>
                }
            </Modal.Body>
            <Modal.Footer className='justify-content-center'>
                <button
                    className="btn btn-cancel me-2"
                    onClick={(e) => onModalHide(e, false)}
                    disabled={loading}
                >
                    Regresar
                </button>
                {
                    loading &&
                    <button disabled={loading} className="btn btn-submit">
                        <Spinner animation="border" role="status" size="sm" />
                    </button>
                }
                {
                    !loading &&
                    <button
                        className={method ? method?.className : "btn btn-primary"}
                        onClick={() => onConfirm()}
                        disabled={!(isValidAmount()?.enabled) || loading}>
                        Procesar Orden
                    </button>
                }
            </Modal.Footer>
        </Modal>
    );
};

CustomTotalModal.propTypes = {
    id: PropTypes.string.isRequired,
    show: PropTypes.bool,
    method: PropTypes.object,
    onHide: PropTypes.func,
    onSubmit: PropTypes.func,
    totalAmount: PropTypes.number.isRequired,
};


export default CustomTotalModal;
